import * as React from "react"
import Section from "../../../../core/layout/main/section/Section"
import * as classNames from "./RhJobAdLastBannersSection.module.scss"
import Button from "../../../common/blocks/button/Button"
import Banner from "./banner/Banner"

const RhJobAdLastBannersSection = (props) => {
  const {
    bannerTitle,
    bannerCount,
    jobAdCountPerBanner,
    buttonText,
    buttonRoute,
    lastJobAds,
  } = props

  const banners = []

  for (const x of Array(bannerCount).keys()) {
    const ads = lastJobAds?.slice(
      x * jobAdCountPerBanner,
      (x + 1) * jobAdCountPerBanner
    )
    banners.push(
      <Banner
        isLeft={!!(x % 2)}
        jobAds={ads}
        key={x}
      />
    )
  }

  return (
    <Section
      className={`pbl-6 pin-0 ${classNames.rhjobadlastbanners}`}
      container="xxlarge"
    >
      <div className="text-center mb-4 loadin">
        <h2>{bannerTitle}</h2>
      </div>
      {banners}
      <div className="section__button text-center mt-6">
        <Button
          aspect="classique"
          color="secondary"
          to={buttonRoute}
        >
          {buttonText}
        </Button>
      </div>
    </Section>
  )
}

export const name = "RhJobAdLastBannersSection"

export const init = (componentData, pageContext) => {
  return (
    <RhJobAdLastBannersSection
      key={componentData.id}
      bannerTitle={componentData.bannerTitle}
      bannerCount={componentData.bannerCount}
      jobAdCountPerBanner={componentData.jobAdCountPerBanner}
      buttonText={componentData.buttonMoreJobOffer?.text}
      buttonRoute={
        componentData.buttonMoreJobOffer?.simplePage?.data?.attributes.route
      }
      lastJobAds={pageContext.lastJobAds}
    />
  )
}

export default RhJobAdLastBannersSection
